export interface NewListingDiscountDetermineEnrollmentPayload {
  agencyUid: string;
  propertyUid: string;
}

export interface NewListingDiscountDetermineEnrollmentResponse {
  enrolled: boolean;
  ineligibilityReasons: string[];
  name: string;
  status: string;
}

export interface NewListingDiscountOptInOutPayload {
  agencyUid: string;
  propertyUid: string;
}

export interface NewListingDiscountOptInOutResponse {
  success: true;
}

export enum NewListingDiscountOperation {
  OPT_IN = 'opt-in',
  OPT_OUT = 'opt-out',
}
